import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { TrustScoreRing, TrustScoreBreakdown } from '../../components/TrustScore/TrustScore';
import { QuoteActivityChart, QuoteHeatMap } from '../../components/Analytics/AnalyticsCharts';
import { Eye, MessageSquare, Star, TrendingUp, MapPinned, Award } from 'lucide-react';

function OverviewTab({ 
  trustScore, 
  profileViews, 
  quoteRequests, 
  reviewCount, 
  analytics, 
  isActive, 
  isListed, 
  isFoundingMember, 
  coverageStats 
}) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="card-base">
          <CardContent className="p-4 flex items-center gap-3">
            <TrustScoreRing score={trustScore} size="xs" />
            <div>
              <p className="text-xs text-slate-500">Servio Score</p>
              <p className="text-xl font-bold text-white">{trustScore}</p>
            </div>
          </CardContent>
        </Card>
        <Card className="card-base">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 text-slate-500 mb-1">
              <Eye className="h-4 w-4 text-teal-400" />
              <span className="text-sm">Profile Views</span>
            </div>
            <p className="text-2xl font-bold text-white">{profileViews}</p>
          </CardContent>
        </Card>
        <Card className="card-base">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 text-slate-500 mb-1">
              <MessageSquare className="h-4 w-4 text-purple-400" />
              <span className="text-sm">Quote Requests</span>
            </div>
            <p className="text-2xl font-bold text-white">{quoteRequests}</p>
          </CardContent>
        </Card>
        <Card className="card-base">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 text-slate-500 mb-1">
              <Star className="h-4 w-4 text-amber-400" />
              <span className="text-sm">Reviews</span>
            </div>
            <p className="text-2xl font-bold text-white">{reviewCount}</p>
          </CardContent>
        </Card>
      </div>
      
      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="card-base">
          <CardHeader>
            <CardTitle className="text-base text-white flex items-center gap-2">
              <TrendingUp className="h-4 w-4 text-teal-400" />
              Quote Activity (Last 14 Days)
            </CardTitle>
          </CardHeader>
          <CardContent>
            <QuoteActivityChart data={analytics ? analytics.quote_activity : null} />
          </CardContent>
        </Card>
        <Card className="card-base">
          <CardHeader>
            <CardTitle className="text-base text-white flex items-center gap-2">
              <MapPinned className="h-4 w-4 text-cyan-400" />
              Quote Request Origins
            </CardTitle>
          </CardHeader>
          <CardContent>
            <QuoteHeatMap data={analytics ? analytics.quote_origins : null} />
          </CardContent>
        </Card>
      </div>
      
      <div className="grid lg:grid-cols-2 gap-6">
        <Card className="card-base">
          <CardHeader><CardTitle className="text-base text-white">Servio Score Breakdown</CardTitle></CardHeader>
          <CardContent>
            <TrustScoreBreakdown trustScore={analytics ? analytics.trust_score : null} />
          </CardContent>
        </Card>
        <Card className="card-base">
          <CardHeader><CardTitle className="text-base text-white">Account Status</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-slate-400">Subscription</span>
              <Badge className={isActive ? 'bg-teal-500/20 text-teal-400 border-teal-500/30' : 'bg-slate-800 text-slate-400 border-slate-700'}>{isActive ? 'Active' : 'Inactive'}</Badge>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-400">Profile Status</span>
              <Badge className={isListed ? 'bg-teal-500/20 text-teal-400 border-teal-500/30' : 'bg-slate-800 text-slate-400 border-slate-700'}>{isListed ? 'Live' : 'Hidden'}</Badge>
            </div>
            {isFoundingMember && (
              <div className="flex items-center justify-between">
                <span className="text-slate-400">Founding Member</span>
                <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30"><Award className="h-3 w-3 mr-1" />Yes</Badge>
              </div>
            )}
            <div className="flex items-center justify-between">
              <span className="text-slate-400">Coverage Areas</span>
              <span className="font-medium text-white" title={coverageStats.breakdown ? 
                (coverageStats.breakdown.counties?.length ? 'Counties: ' + coverageStats.breakdown.counties.join(', ') : '') +
                (coverageStats.breakdown.zips?.length ? ' | ZIPs: ' + coverageStats.breakdown.zips.join(', ') : '') : ''
              }>{coverageStats.count} unique</span>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default OverviewTab;
